const CONNECTION_STATUS_EVENT = "tb-public-web-connection-status";

export type ConnectionStatus = {
  online: boolean;
};

function readOnline(): boolean {
  if (typeof navigator === "undefined") return true;
  return navigator.onLine !== false;
}

let connectionStatus: ConnectionStatus = { online: readOnline() };

function notifyConnectionStatusChanged() {
  if (typeof window === "undefined") return;
  try {
    window.dispatchEvent(new CustomEvent(CONNECTION_STATUS_EVENT));
  } catch {
    /* connection status is best-effort */
  }
}

function refreshConnectionStatus() {
  const next = readOnline();
  if (connectionStatus.online === next) return;
  connectionStatus = { online: next };
  notifyConnectionStatusChanged();
}

export function getConnectionStatus(): ConnectionStatus {
  return connectionStatus;
}

export function onConnectionStatusChanged(listener: () => void): () => void {
  if (typeof window === "undefined") return () => {};
  window.addEventListener("online", refreshConnectionStatus);
  window.addEventListener("offline", refreshConnectionStatus);
  window.addEventListener(CONNECTION_STATUS_EVENT, listener);
  refreshConnectionStatus();
  return () => {
    window.removeEventListener("online", refreshConnectionStatus);
    window.removeEventListener("offline", refreshConnectionStatus);
    window.removeEventListener(CONNECTION_STATUS_EVENT, listener);
  };
}
